// extracted by mini-css-extract-plugin
export default {"root":"MediaDisplay-module-root-j81TU","video":"MediaDisplay-module-video-cgF9S","visible":"MediaDisplay-module-visible-yICeZ"};